import { FileModel } from "../../../Shared/dto/create-file-input";

export class CreateCompanyInput {
  id?: string;
  userId?: string;
  name?: string;
  country?: string;
  address?: string;
  description?: string;
  license?: FileModel;
  taxPayerId?: FileModel;
  registration?: FileModel;
  attachments?: FileModel[];
   
}
